export default __webpack_public_path__ + "static/media/reception.26cf70e8.svg";